/* eslint-disable */
// @flow

import React from 'react';
import styles from './styles.module.scss';

type Props = {
  text: string,
  textAdd?: string,
  handleClick: () => void,
  isChecked: boolean,
  customBackground?: string,
  disabled?: boolean,
  setFreeModalVisible?: () => void,
  isFreeUser?: boolean,
}

const PressButton = ({
  text,
  textAdd,
  handleClick,
  isChecked,
  customBackground,
  disabled = false,
  setFreeModalVisible,
  isFreeUser,
}: Props) => (
  <button
    className={`${styles.buttonBase} ${disabled ? styles.disabled : null}`}
    style={{ background: customBackground }}
    type="button"
    onClick={(e) => (disabled ? null : handleClick(e))}
    onMouseOver={() => (isFreeUser ? setFreeModalVisible(true) : null)}
    onFocus={() => (isFreeUser ? setFreeModalVisible(true) : null)}
    onMouseOut={() => (isFreeUser ? setFreeModalVisible(false) : null)}
    onBlur={() => (isFreeUser ? setFreeModalVisible(false) : null)}
  >

    <div className={`${styles.innerButton} ${isChecked ? styles.active : null} ${textAdd ? styles.smallerText : null}`}>
      {text}
      {textAdd && <><br/>{ textAdd }</>}
    </div>
  </button>
);

export default PressButton;
